import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { persistor } from "../../redux/Store";
import {
  Box,
  CssBaseline,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  useMediaQuery,
  Drawer,
  Collapse,
  Popover
} from "@mui/material";

import {
  Dashboard,
  Menu,
  ExpandLess,
    ExpandMore,
  AddBoxOutlined,
  LanguageRounded,
  AssignmentIndOutlined,
  CalendarMonthOutlined,
  FormatListBulletedOutlined,
  Group,
  History,
  LocalTaxi,
  Edit,
  SignalCellularAltOutlined,
  ReceiptLong,
  Gavel,
  Logout
} from "@mui/icons-material";

import { styled } from "@mui/material/styles";

import { toast } from "react-toastify";
import { resetContact } from "../../redux/reducers/contactReducer";
import { resetHomeRe } from "../../redux/reducers/homeReducer";
import { paths } from "../../config/constants";
import { useDispatch,useSelector } from "react-redux";
import { reset } from "../../redux/reducers/login";
import { authToken } from "../../redux/reducers/login";
import { clearSession } from "../../component/Elements/Session";
import { logoutUser } from "../../component/Elements/Session";
import useSessionTimeout from "../../component/Elements/useSessionTimeout";

/* ================= WIDTH ================= */

const drawerWidthExpanded = 240;
const drawerWidthCollapsed = 70;

/* ================= STYLES ================= */

const SidebarContainer = styled(Box)(({ collapsed }) => ({
  width: collapsed ? drawerWidthCollapsed : drawerWidthExpanded,
  backgroundColor: "#0E4672",
  color: "#fff",
  display: "flex",
  flexDirection: "column",
  overflowX: "hidden",
  height: "100%"
}));

const StyledItem = styled(ListItemButton)(({ active }) => ({
  padding: "12px 20px",
  color: "#fff",
  borderLeft: active ? "4px solid #f16729" : "4px solid transparent",
  backgroundColor: active ? "#293846" : "transparent",
  "&:hover": {
    backgroundColor: "#293846",
    color: "#fff"
  }
}));

/* ================= SIDEBAR ================= */

function SidebarContent({ collapsed }) {
const location = useLocation();
  const navigate = useNavigate();
    const [openTermsAndPolicies, setOpenTermsAndPolicies] = useState(false);
     const reduxdata = useSelector((state) => state);
  const userId = reduxdata?.login?.user?.data?._id;
    let token = reduxdata?.login?.token;
  console.log("userID",userId)
  const dispatch = useDispatch();
    const [isProfileCompleted, setIsProfileCompleted] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const [role,setRole]=useState(null)
  const [deactivatedStatusReason,setDeactivatedStatusReason]=useState(null)
    const [bluCommission,setBluCommission]=useState(null)
     const [toastShown, setToastShown] = useState(false);
       const [termsAndPolicyAnchor, setTermsAndPolicyAnchor] = useState(null); 
       const [openReports, setOpenReports] = useState(false);
        const [reportsAnchor, setReportsAnchor] = useState(null); 
         useSessionTimeout();

const handleLogout = async () => {
  await logoutUser({
    dispatch,
    navigate,
  });
};

const handleExpire = async () => {
  await logoutUser({
    dispatch,
    navigate,
    expired: true,
  });
};



  const navigationState = {
  bluCommission,
  isProfileCompleted,
  deactivatedStatusReason
};


  const fetchData = async () => {
    let obj = {
      userId: userId,
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/user/getUserProfile`,
        obj
      );
      console.log(res?.data?.data);
         const profileCompleted = res?.data?.data?.isProfileCompleted;

    setIsProfileCompleted(profileCompleted);
    setAccountType(res?.data?.data?.accountType);
    setRole(res?.data?.data?.role);
    setBluCommission(res?.data?.data?.bluCommission);
    setDeactivatedStatusReason(res?.data?.data?.deactivatedStatusReason);

    // ✅ Set default active menu
   if (profileCompleted === false) {
  navigate("/driverCarrier/edit-profile");
} 
    } catch (error) {}
  };

  useEffect(() => {
      fetchData();
    }, []);

    const sectionConfig = {
  booking: {
    active: "createBooking",
    route: "/driverCarrier/createBooking",
    action: "create a booking",
  },
  drivers: {
    active: "drivers",
    route: "/driverCarrier/driverList",
    action: "manage drivers",
  },
  vehicles: {
    active: "vehicles",
    route: "/driverCarrier/vehicles",
    action: "manage vehicles",
  },
};

 const handleCreateBookingClick = (event, section) => {
  const config = sectionConfig[section];

  if (!config) return;

  if (isProfileCompleted === false) {
    event.preventDefault();

    if (!toastShown) {
      toast.info(
        `You cannot ${config.action} because your profile is incomplete. Kindly complete it using Edit Profile.`,
        { autoClose: 2500 }
      );

      setToastShown(true);
      setTimeout(() => setToastShown(false), 2500);
    }
    return;
  }

  if (bluCommission === null) {
    event.preventDefault();

    if (!toastShown) {
      toast.info(
        `You cannot ${config.action} because your commission has not yet been set. Contact customer support.`,
        { autoClose: 2500 }
      );

      setToastShown(true);
      setTimeout(() => setToastShown(false), 2500);
    }
    return;
  }

  if (deactivatedStatusReason !== "N/A") {
    event.preventDefault();

    if (!toastShown) {
      toast.info(
        `You cannot ${config.action} because your account is deactivated for this reason: ${deactivatedStatusReason}.`,
        { autoClose: 2500 }
      );

      setToastShown(true);
      setTimeout(() => setToastShown(false), 2500);
    }
    return;
  }

  // ✅ Dynamic navigation
  navigate(config.route);
};


  return (
    <SidebarContainer collapsed={collapsed}>

      {/* LOGO */}
      <Box
     onClick={() => {
  navigate("/driverCarrier/dashboard");
}}
        sx={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          cursor: "pointer"
        }}
      >
        <img
          src="https://blu.taxi/static/media/BLU%20TAXI%20white%20logo.4f586d7f9285146a885b.png"
          alt="BLU TAXI"
          style={{ width: collapsed ? 40 : 140 }}
        />
      </Box>

      <List>

        {/* DASHBOARD */}

     <StyledItem
  active={location.pathname === "/driverCarrier/dashboard"}
  onClick={() => navigate("/driverCarrier/dashboard")}
>
          <ListItemIcon sx={{ color: "#fff" }}>
            <Dashboard />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Dashboard" />}
        </StyledItem>

        {/* OPEN BOOKINGS */}

        <StyledItem
  active={location.pathname === "/driverCarrier/openBooking"}
  onClick={() =>
    navigate("/driverCarrier/openBooking", { state: navigationState })
  }
>
          <ListItemIcon sx={{ color: "#fff" }}>
            <LanguageRounded />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Open Bookings" />}
        </StyledItem>

        {/* ASSIGN DRIVER */}

        <StyledItem
  active={location.pathname === "/driverCarrier/assignDriverVehicle"}
  onClick={() =>
    navigate("/driverCarrier/assignDriverVehicle", { state: navigationState })
  }
>
          <ListItemIcon sx={{ color: "#fff" }}>
            <AssignmentIndOutlined />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Assign Driver" />}
        </StyledItem>

        {/* UPCOMING BOOKINGS */}

        <StyledItem
          active={location.pathname === "/driverCarrier/upcomingBookings"}
          onClick={() => {
            navigate("/driverCarrier/upcomingBookings", {
  state: navigationState
});
          }}
        >
          <ListItemIcon sx={{ color: "#fff" }}>
            <CalendarMonthOutlined />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Upcoming Bookings" />}
        </StyledItem>

        {/* CREATE BOOKING */}

        {/* CREATE BOOKING */}
<StyledItem
  active={location.pathname === "/driverCarrier/createBooking"}
  onClick={() => navigate("/driverCarrier/createBooking")}
>
          <ListItemIcon sx={{ color: "#fff" }}>
            <AddBoxOutlined />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Create Booking" />}
        </StyledItem>

        {/* MY BOOKINGS */}

        <StyledItem
         active={location.pathname === "/driverCarrier/myBookings"}
          onClick={() => {
            navigate("/driverCarrier/myBookings");
          }}
        >
          <ListItemIcon sx={{ color: "#fff" }}>
            <FormatListBulletedOutlined />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="My Bookings" />}
        </StyledItem>

        {/* DRIVERS */}

        <StyledItem
          active={location.pathname === "/driverCarrier/driverList"}
          onClick={(event) => handleCreateBookingClick(event, "drivers")}

        >
          <ListItemIcon sx={{ color: "#fff" }}>
            <Group />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Add / Edit Drivers" />}
        </StyledItem>

        {/* VEHICLES */}

        <StyledItem
          active={location.pathname === "/driverCarrier/vehicles"}
           onClick={(event) => handleCreateBookingClick(event, "vehicles")}
        >
          <ListItemIcon sx={{ color: "#fff" }}>
            <LocalTaxi />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Add / Edit Vehicles" />}
        </StyledItem>

        {/* EDIT PROFILE */}

        <StyledItem
          active={location.pathname === "/driverCarrier/edit-profile"}
          onClick={() => {
            navigate("/driverCarrier/edit-profile");
          }}
        >
          <ListItemIcon sx={{ color: "#fff" }}>
            <Edit />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Edit Profile" />}
        </StyledItem>

        {/* REPORTS */}

        <StyledItem
  active={
    location.pathname === "/driverCarrier/MyBookingsReport" ||
    location.pathname === "/driverCarrier/DriverReport" ||
    location.pathname === "/driverCarrier/VehicleReport"
  }
   onClick={(e) => {
    if (collapsed) {
      setReportsAnchor(e.currentTarget); // popup when collapsed
    } else {
      setOpenReports(!openReports) // expand when open sidebar
    }
  }}
>
          <ListItemIcon sx={{ color: "#fff" }}>
            <SignalCellularAltOutlined />
          </ListItemIcon>
          {!collapsed && (
            <>
              <ListItemText primary="Reports" />
              {openReports ? <ExpandLess /> : <ExpandMore />}
            </>
          )}
        </StyledItem>
        
                <Collapse in={openReports && !collapsed} timeout="auto">
                  <List component="div" disablePadding>
        
                   <StyledItem
          active={location.pathname === "/driverCarrier/MyBookingsReport"}
          sx={{ pl: 6 }}
          onClick={() => {
            navigate(
               "/driverCarrier/MyBookingsReport"
            );
          }}
        >
                      <ListItemText primary="My Booking Report" />
                    </StyledItem>
        
                   <StyledItem
          active={location.pathname === "/driverCarrier/DriverReport"}
          sx={{ pl: 6 }}
          onClick={() => {
            navigate("/driverCarrier/DriverReport");
          }}
        >
                      <ListItemText primary="Driver Report" />
                    </StyledItem>


                    <StyledItem
          active={location.pathname === "/driverCarrier/VehicleReport"}
          sx={{ pl: 6 }}
          onClick={() => {
            navigate("/driverCarrier/VehicleReport");
          }}
        >
                      <ListItemText primary="Vehicle Report" />
                    </StyledItem>
        
                  </List>
                </Collapse>

                 <Popover
                              open={Boolean(reportsAnchor)}
                              anchorEl={reportsAnchor}
                              onClose={() => setReportsAnchor(null)}
                              anchorOrigin={{
                                vertical: "center",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "center",
                                horizontal: "left",
                              }}
                              PaperProps={{
                                sx: {
                                  backgroundColor: "#0E4672",
                                  color: "#fff",
                                  borderRadius: "8px",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.3)"
                                }
                              }}
                            >
                              <List sx={{ minWidth: 200 }}>
                            
                                <ListItemButton
  sx={{
    color: "#fff",
    "&:hover": { backgroundColor: "#293846" }
  }}
  onClick={() => { 
    setReportsAnchor(null);
    navigate(paths.driverCarrier.CarrierMyBookingsReports);
  }}
>
                                  <ListItemText primary="My Booking Report" />
                                </ListItemButton>
                            
                                <ListItemButton
  sx={{
    color: "#fff",
    "&:hover": { backgroundColor: "#293846" }
  }}
  onClick={() => { 
    setTermsAndPolicyAnchor(null);
    navigate(paths.driverCarrier.driverReport);
  }}
>
                                  <ListItemText primary="Driver Report" />
                                </ListItemButton>

 <ListItemButton
  sx={{
    color: "#fff",
    "&:hover": { backgroundColor: "#293846" }
  }}
  onClick={() => { 
    setTermsAndPolicyAnchor(null);
    navigate(paths.driverCarrier.vehicleReport);
  }}
>
                                  <ListItemText primary="Vehicle Report" />
                                </ListItemButton>

                              </List>
                            </Popover>

        <StyledItem
          active={location.pathname === "/driverCarrier/CarrierRideHistory"}
          onClick={() => {
            navigate("/driverCarrier/CarrierRideHistory");
          }}
        >
          <ListItemIcon sx={{ color: "#fff" }}>
            <History />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Ride History" />}
        </StyledItem>

        {/* INVOICES */}

        <StyledItem
          active={location.pathname === "/driverCarrier/CarrierInvoiceHistory"}
          onClick={() => {
            navigate("/driverCarrier/CarrierInvoiceHistory");
          }}
        >
          <ListItemIcon sx={{ color: "#fff" }}>
            <ReceiptLong />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Invoice History" />}
        </StyledItem>

        {/* TERMS */}

<StyledItem
  active={
    location.pathname === "/driverCarrier/CarrierTermsAndConditions" ||
    location.pathname === "/driverCarrier/CarrierCancellationPolicy"
  }
   onClick={(e) => {
    if (collapsed) {
      setTermsAndPolicyAnchor(e.currentTarget); // popup when collapsed
    } else {
      setOpenTermsAndPolicies(!openTermsAndPolicies) // expand when open sidebar
    }
  }}
>
          <ListItemIcon sx={{ color: "#fff" }}>
            <Gavel />
          </ListItemIcon>
          {!collapsed && (
            <>
              <ListItemText primary="Terms & Policies" />
              {openTermsAndPolicies ? <ExpandLess /> : <ExpandMore />}
            </>
          )}
        </StyledItem>
        
                <Collapse in={openTermsAndPolicies && !collapsed} timeout="auto">
                  <List component="div" disablePadding>
        
                   <StyledItem
          active={location.pathname === "/driverCarrier/CarrierTermsAndConditions"}
          sx={{ pl: 6 }}
          onClick={() => {
            navigate(
               "/driverCarrier/CarrierTermsAndConditions"
            );
          }}
        >
                      <ListItemText primary="Terms and Conditions" />
                    </StyledItem>
        
                   <StyledItem
          active={location.pathname === "/driverCarrier/CarrierCancellationPolicy"}
          sx={{ pl: 6 }}
          onClick={() => {
            navigate("/driverCarrier/CarrierCancellationPolicy");
          }}
        >
                      <ListItemText primary="Cancellation Policy" />
                    </StyledItem>
        
                  </List>
                </Collapse>

                 <Popover
                              open={Boolean(termsAndPolicyAnchor)}
                              anchorEl={termsAndPolicyAnchor}
                              onClose={() => setTermsAndPolicyAnchor(null)}
                              anchorOrigin={{
                                vertical: "center",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "center",
                                horizontal: "left",
                              }}
                              PaperProps={{
                                sx: {
                                  backgroundColor: "#0E4672",
                                  color: "#fff",
                                  borderRadius: "8px",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.3)"
                                }
                              }}
                            >
                              <List sx={{ minWidth: 200 }}>
                            
                                <ListItemButton
  sx={{
    color: "#fff",
    "&:hover": { backgroundColor: "#293846" }
  }}
  onClick={() => { 
    setTermsAndPolicyAnchor(null);
    navigate(paths.driverCarrier.carrierTermsAndConditions);
  }}
>
                                  <ListItemText primary="Terms & Conditions" />
                                </ListItemButton>
                            
                                <ListItemButton
  sx={{
    color: "#fff",
    "&:hover": { backgroundColor: "#293846" }
  }}
  onClick={() => { 
    setTermsAndPolicyAnchor(null);
    navigate(paths.driverCarrier.carrierCancellationPolicy);
  }}
>
                                  <ListItemText primary="Cancellation Policy" />
                                </ListItemButton>
                            
                              </List>
                            </Popover>

        {/* LOGOUT */}

        <StyledItem onClick={handleLogout}>
          <ListItemIcon sx={{ color: "#ff4d4f" }}>
            <Logout />
          </ListItemIcon>
          {!collapsed && (
            <ListItemText primary="Logout" sx={{ color: "#ff4d4f" }} />
          )}
        </StyledItem>

      </List>
    </SidebarContainer>
  );
}

/* ================= MAIN LAYOUT ================= */

export default function CarrierLayout() {

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:1024px)");
  const isLaptopOrAbove = useMediaQuery("(min-width:1025px)");

  const username = localStorage.getItem("userName");
  const userId = localStorage.getItem("userID");

  const [collapsed, setCollapsed] = useState(false);
  const [mobileCollapsed, setMobileCollapsed] = useState(true);

  const handleMenuClick = () => {

    if (isMobile || isTablet) {
      setMobileCollapsed(prev => !prev);
    } else {
      setCollapsed(prev => !prev);
    }

  };

  return (

    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <CssBaseline />

      {/* DESKTOP SIDEBAR */}

      {isLaptopOrAbove && (
        <Box sx={{ width: collapsed ? drawerWidthCollapsed : drawerWidthExpanded }}>
          <SidebarContent collapsed={collapsed} />
        </Box>
      )}

      {/* MOBILE DRAWER */}

      {(isMobile || isTablet) && (

        <Drawer
          variant="temporary"
          open={!mobileCollapsed}
          onClose={() => setMobileCollapsed(true)}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidthExpanded,
              backgroundColor: "#0E4672"
            }
          }}
        >
          <SidebarContent collapsed={false} />
        </Drawer>

      )}

      {/* MAIN CONTENT */}

    <Box
  sx={{
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0
  }}
>

        {/* HEADER */}

        <Box
          sx={{
            height: 60,
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            borderBottom: "1px solid #e5e5e5",
            position: "relative"
          }}
        >

          <IconButton
            onClick={handleMenuClick}
            sx={{
              backgroundColor: "#f16729",
              color: "#fff",
              "&:hover": { backgroundColor: "#f16729" }
            }}
          >
            <Menu />
          </IconButton>

          {/* DASHBOARD TITLE */}

          {!isMobile && (
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                fontWeight: 600,
                fontSize: 16
              }}
            >
              Carrier Dashboard
            </Box>
          )}

          {/* USER */}

          <Box
            sx={{
              textAlign: "right",
              mr: { xs: 3, sm: 5, md: 0 }
            }}
          >

            <Box sx={{ fontSize: 15, fontWeight: 600 }}>
              {username}
            </Box>

            <Box sx={{ fontSize: 14 }}>
              ID: {userId}
            </Box>

          </Box>

        </Box>

        {/* PAGE CONTENT */}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            backgroundColor: "#f3f3f4",
            px: { xs: 2, sm: 3, md: 4 },
            py: 3,
            width: "100%",
            overflowX: "hidden"
          }}
        >
          <Outlet />
        </Box>

      </Box>

    </Box>

  );
}